import React from "react";

class NightAuditPresenterSummary extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t("summary")}</h3>
          <div className="row container">
            <div className="col-md-12">
              <table className="table table-bordered">
                {this.renderSummaryTableHead()}
                {this.renderSummaryTableBody()}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSummaryTableHead() {
    return (
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("items")}</th>
          <th scope="col">{I18n.t("lodging")}</th>
          <th scope="col">{I18n.t("products")}</th>
          <th scope="col">{I18n.t("fees")}</th>
          <th scope="col">{I18n.t("taxes")}</th>
          <th scope="col">{I18n.t("total")}</th>
        </tr>
      </thead>
    );
  };

  renderSummaryTableBody() {
    
      return (
        <tbody>
          <tr>
            <td>{this.props.night_audit.counts.folio_items_total_count}</td>
            <td>{this.props.formatCurrency(this.props.night_audit.totals.lodging)}</td>
            <td>{this.props.formatCurrency(this.props.night_audit.totals.products)}</td>
            <td>{this.props.formatCurrency(this.props.night_audit.totals.fees)}</td>
            <td>{this.props.formatCurrency(this.props.night_audit.totals.taxes)}</td>
            <td>{this.props.formatCurrency(this.props.night_audit.totals.folio_item_totals)}</td>
          </tr>
        </tbody>
      );

  };

}

export default NightAuditPresenterSummary